import script from "./ReservationManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationManager.vue?vue&type=script&setup=true&lang=js"

import "./ReservationManager.vue?vue&type=style&index=0&id=5ffa45fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ffa45fe"]])

export default __exports__